import { Alert, Button, Group, Paper, Title } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../api";
import { AlertPresets } from "../../mantine/mantinePresets";
import { useToast } from "../../mantine/notifications/useToast";
import urls from "../../urls";
import { FormField } from "../BuildingBlocks/Forms/MantineFormFields/FormField";

interface ChangePasswordFormState {
  currentPass: string;
  newPass: string;
  newPassConfirm: string;
}

function ChangePasswordForm() {
  const { showToast } = useToast();
  const { t } = useTranslation();
  const [error, setError] = useState<string | Array<string> | null>(null);
  const [isChangingPass, setIsChangingPass] = useState(false);
  const [formState, setFormState] = useState<ChangePasswordFormState>({
    currentPass: "",
    newPass: "",
    newPassConfirm: ""
  });

  async function handleSubmitResetPass(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (formState.newPass !== formState.newPassConfirm) {
      setError("Passwörter stimmen nicht überein.");
      return;
    }

    if (
      !formState.currentPass ||
      !formState.newPass ||
      !formState.newPassConfirm
    ) {
      setError("Bitte füllen Sie alle Eingabefelder aus.");
      return;
    }

    setError(null);
    setIsChangingPass(true);

    try {
      await api.post(urls.api.changePassword(), {
        old_password: formState.currentPass,
        new_password1: formState.newPass,
        new_password2: formState.newPassConfirm
      });

      showToast({
        type: "success",
        message: "Passwort wurde erfolgreich geändert"
      });
      setFormState({
        currentPass: "",
        newPass: "",
        newPassConfirm: ""
      });
    } catch (error) {
      setError(
        error.response?.data?.[Object.keys(error.response?.data)[0]] ||
          t("errors.Login.ChangePasswordError")
      );
    } finally {
      setIsChangingPass(false);
    }
  }

  return (
    <Paper mb="lg">
      <Title variant="paper-header">Passwort zurücksetzen</Title>
      <form onSubmit={handleSubmitResetPass}>
        <FormField
          label="Aktuelles Passwort"
          name="currentPassword"
          required
          type="password"
          value={formState.currentPass}
          onChange={(event) => {
            setFormState((prevState) => ({
              ...prevState,
              currentPass: event.target.value
            }));
          }}
        />
        <FormField
          label="Neues Passwort"
          name="newPass"
          required
          type="password"
          value={formState.newPass}
          onChange={(event) =>
            setFormState((prevState) => ({
              ...prevState,
              newPass: event.target.value
            }))
          }
        />
        <FormField
          label="Neues Passwort (Wiederholung)"
          name="newPassConfirm"
          required
          type="password"
          value={formState.newPassConfirm}
          onChange={(event) => {
            setFormState((prevState) => ({
              ...prevState,
              newPassConfirm: event.target.value
            }));
          }}
        />

        {error && (
          <Alert color={AlertPresets.error.color}>
            {Array.isArray(error)
              ? error.map((err) => <p key={err}>{err}</p>)
              : error}
          </Alert>
        )}

        <Group variant="paper-footer">
          <Button color="secondary" loading={isChangingPass} type="submit">
            Speichern
          </Button>
        </Group>
      </form>
    </Paper>
  );
}

export { ChangePasswordForm };
